import type { ReactNode } from "react"
import { Button } from "@/components/catalyst/button"

/** Application UI "table in a card": the table sits in a bordered, rounded panel with an optional footer. */
export function TableCard({ children, footer }: { children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="overflow-hidden rounded-xl bg-page ring-1 ring-hairline">
      <div className="overflow-x-auto">{children}</div>
      {footer && <div className="border-t border-hairline px-4 py-3 sm:px-6">{footer}</div>}
    </div>
  )
}

/** Application UI "simple card footer" pagination: a result count and previous / next. */
export function CardPagination({ from, to, total }: { from: number; to: number; total: number }) {
  return (
    <nav aria-label="Pagination" className="flex items-center justify-between">
      <p className="text-sm text-ink-body">
        Showing <span className="font-medium">{from}</span> to <span className="font-medium">{to}</span> of{" "}
        <span className="font-medium">{total}</span> results
      </p>
      <div className="flex gap-3">
        <Button outline disabled={from === 1}>
          Previous
        </Button>
        <Button outline disabled={to === total}>
          Next
        </Button>
      </div>
    </nav>
  )
}
